/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentWithPrepaidTransaction
 */
export interface PaymentWithPrepaidTransaction {
    /**
     * 
     * @type {string}
     * @memberof PaymentWithPrepaidTransaction
     */
    prepaidAccountId?: string;
}

/**
 * Check if a given object implements the PaymentWithPrepaidTransaction interface.
 */
export function instanceOfPaymentWithPrepaidTransaction(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaymentWithPrepaidTransactionFromJSON(json: any): PaymentWithPrepaidTransaction {
    return PaymentWithPrepaidTransactionFromJSONTyped(json, false);
}

export function PaymentWithPrepaidTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentWithPrepaidTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prepaidAccountId': !exists(json, 'prepaidAccountId') ? undefined : json['prepaidAccountId'],
    };
}

export function PaymentWithPrepaidTransactionToJSON(value?: PaymentWithPrepaidTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prepaidAccountId': value.prepaidAccountId,
    };
}

